<script>
	import DotIcon from '$lib/images/svg/dot.svelte';
	import HomeIcon from '$lib/images/svg/home.svelte';
	export let breadcrumbs = [];
</script>

<nav aria-label="Breadcrumb" class="container mx-auto">
	<ul
		class="m-0 custom-horizontal-scrollbar flex items-center gap-x-4 overflow-x-auto whitespace-nowrap px-2.5 py-3 text-sm lg:border-b"
	>
		<li class="flex items-center">
			<a href="/" title="Scootland" class="inline-flex items-center font-medium">
				<HomeIcon class="w-4 text-gray-shark" />
			</a>
		</li>

		{#if breadcrumbs?.length > 0}
			{#each breadcrumbs as item, index}
				{#if item.link !== null}
					<li aria-current="page" title={item.name}>
						{#if index === breadcrumbs.length - 1}
							<span class="flex flex-row items-center gap-x-4">
								<DotIcon class="h-1.5 text-yellow" />
								<span class="text-gray-shark">{item.name}</span>
							</span>
						{:else}
							<a
								href={item.link}/
								class="flex flex-row items-center gap-x-4 underline hover:no-underline"
							>
								<DotIcon class="h-1.5 text-yellow" />
								<span class="text-gray-shark">{item.name}</span>
							</a>
						{/if}
					</li>
				{/if}
			{/each}
		{/if}
	</ul>
</nav>
